var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_GeoJsonData_class = function (in_implements) {
    return new Class({
        Extends: OCS.Functions.define_Data_class(in_implements),
        class_name: "GeoJsonData",
        data_type: 'GeoJsonData',
        options: {
            entry: {
                json: {
                    data: {
                        features: [],
                        type: 'FeatureCollection'
                    },
                    dataset: '',
                    payload: false,
                    info: {}
                }
            }
        },
        get_data_type: function () {
            return this.options.entry.json.data.type;
        }
    });
};
OCS.Classes.GeoJsonData = OCS.Functions.define_GeoJsonData_class();
